module.exports = __webpack_public_path__ + "img/people_counter.4cafd527.png";